import { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { content } from "../i18n/content";
import { scrollToId } from "../lib/scroll";

export const Navbar = () => {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const links = [
    { id: "about", label: content.nav.about, testid: "nav-about-link" },
    { id: "services", label: content.nav.offer, testid: "nav-services-link" },
  ];

  return (
    <motion.header
      initial={{ y: -80, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 1, delay: 0.2, ease: [0.16, 1, 0.3, 1] }}
      className={`fixed top-0 left-0 right-0 z-50 transition-[background-color,box-shadow] duration-500 ${
        scrolled ? "bg-[#f9f6f0]/85 backdrop-blur-xl shadow-[0_1px_0_rgba(42,38,38,0.08)]" : "bg-[#f9f6f0]/60 backdrop-blur-md"
      }`}
      data-testid="main-navbar"
    >
      <div className="max-w-[1500px] mx-auto flex items-center justify-between px-6 sm:px-10 py-5">
        <button
          onClick={() => scrollToId("hero")}
          className="font-display text-xl sm:text-2xl tracking-tight font-semibold text-[#2a2626]"
          data-testid="nav-brand"
        >
          {content.nav.brand}
          <span className="text-[#c86f53]">.</span>
        </button>

        <nav className="hidden md:flex items-center gap-10">
          {links.map((l) => (
            <button
              key={l.id}
              onClick={() => scrollToId(l.id)}
              className="group relative text-[11px] uppercase tracking-[0.22em] text-[#5c5656] hover:text-[#2a2626] transition-colors duration-300"
              data-testid={l.testid}
            >
              {l.label}
              <span className="absolute -bottom-1 left-0 h-px w-0 bg-[#c86f53] transition-[width] duration-500 group-hover:w-full" />
            </button>
          ))}
        </nav>

        <div className="flex items-center gap-5">
          <span
            className="hidden sm:inline-flex items-center gap-2 text-[10px] uppercase tracking-[0.25em] text-[#6b705c] border border-[#6b705c]/30 rounded-full px-4 py-1.5"
            data-testid="language-badge"
          >
            Deutsch · English
          </span>
          <button
            onClick={() => scrollToId("contact")}
            className="inline-flex items-center border border-[#2a2626] rounded-full px-6 py-2.5 text-[11px] uppercase tracking-[0.22em] text-[#2a2626] hover:bg-[#2a2626] hover:text-[#f9f6f0] transition-colors duration-500"
            data-testid="nav-contact-button"
          >
            {content.nav.contact}
          </button>
        </div>
      </div>
    </motion.header>
  );
};
